import type { ReactElement, ReactNode } from 'react';
import React from 'react';
import type { TextStyle, TextProps, Text as RNText } from 'react-native';

import { TYPE_CONFIG } from '@garnish/constants';
import { useFluidTextStyles } from '../useFluidTextStyles';

import { Text } from '../Text';

const PRESET_MAP = { 1: '14', 2: '12', 3: '10' };
const DEFAULT_SIZE: SizeOrdinal = 1;

type Props = {
  readonly size?: SizeOrdinal;
  readonly underline?: boolean;
  readonly children?: ReactNode;
} & TextProps;

export const LabelText = React.forwardRef(
  (props: Props, ref: React.Ref<RNText>): ReactElement<Text> => {
    const { size = DEFAULT_SIZE, style, children, ...rest } = props;
    const responsiveStyles = useFluidTextStyles(PRESET_MAP[size], 'LABEL');

    const stylesFromPresets = getStylesFromPresets(size);
    const labelStyles = [stylesFromPresets, responsiveStyles, style];

    return (
      <Text ref={ref} style={labelStyles} {...rest}>
        {children}
      </Text>
    );
  },
);

/* -- utils, etc ------------------------------------------------------------ */

const getStylesFromPresets = (size: SizeOrdinal): TextStyle => {
  const configKey = PRESET_MAP[size];

  return TYPE_CONFIG.LABEL[configKey];
};

type SizeOrdinal = keyof typeof PRESET_MAP;
